import React from 'react';

function Certificate({ url }) {
    return (
        <div className='cert' id='certificate' >
            <img src={url} alt='certificate' />
        </div>
    )
};

export default Certificate;